import axios from "axios";

/**
 * Retrieve user info based on the username.  Returns
 * the user's IG handle and profile pic.
 * @param  username
 * @returns
 */


export const retrieveUser = async (username, wpApiKey) => {
  const endpoint = `https://${process.env.REACT_APP_DOMAIN}/api/userinfo?u=${username}&c=${wpApiKey}`;
  const userInfo = await axios.get(endpoint);

  console.log(`Raw info from api = ${JSON.stringify(userInfo)}`)
  return await userInfo;
};
